module.exports = __webpack_public_path__ + "img/wrcsfw-gnys.ee4f79a0.png";